import { useHasUserTag, push } from '@centra/centra-ui'

export const useRedirectToCMS = () => {
  const isAdminContent = useHasUserTag('role.admin-content')

  if (!isAdminContent) {
    return true
  }

  push(`${location.origin}/cms`)
  return false
}
